export default "__VITE_ASSET__fk0EXcmu__"